// extracted by mini-css-extract-plugin
export default {"dropZoneContainer":"styles_dropZoneContainer__s9a9J","filterContainer":"styles_filterContainer__8oqdo","downloadButton":"styles_downloadButton__Gw4E1"};